import * as React from "react";
import { Navigate } from "react-router-dom";
import { KuikaSpinner } from "../components/design-tools/spinner/kuika-spinner";
import { UserService } from "../services/user-service";
import { IWithHistoryProp, withHistory } from "../shared/hoc/with-history";
import { KMainFunctions } from "../shared/utility/main-functions";
import LocalStorageService from "./local-storage-service";

export interface IRedirectProps {}

export interface IRedirectState {
  isRedirecting: boolean;
  redirectUrl: string;
}

declare let window: Window & { userInfo: any };

class Redirect extends React.PureComponent<IRedirectProps & IWithHistoryProp, IRedirectState> {
  constructor(props: IRedirectProps & IWithHistoryProp) {
    super(props);
    this.state = {
      isRedirecting: true,
      redirectUrl: ""
    };
  }

  async componentDidMount() {
    try {
      const pathName = this.props.navigator.location.pathname;
      if (pathName === "/redirect") {
        const refreshToken = this.props.navigator.location.search.replace("?token=", "");
        if (refreshToken) {
          LocalStorageService.setToken({ refreshToken });

          if (window.userInfo?.id) {
            this.setState({ isRedirecting: false, redirectUrl: `/${window.userInfo.lastUsedDomainName}/projects` });
          } else {
            const res = await UserService.GetUserInfo();
            if (res && res.id) {
              this.setState({ isRedirecting: false, redirectUrl: `/${res.lastUsedDomainName}/projects` });
            } else {
              this.setState({ isRedirecting: false, redirectUrl: "/login" });
            }
          }
        }
      }

      if (LocalStorageService.getRefreshToken() === null) {
        this.setState({ isRedirecting: false, redirectUrl: "/login" });
        return;
      }

      const res = await UserService.GetUserInfo();
      if (res && res.id) {
        this.setState({ isRedirecting: false, redirectUrl: `/${res.lastUsedDomainName}/projects` });
      } else {
        this.setState({ isRedirecting: false, redirectUrl: "/login" });
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      // A session this component cannot resolve is a session the user does not have. Without
      // this, the failure left `isRedirecting` true and the spinner below ran forever: the app
      // looked like it was still booting, with nothing on screen to act on and no way out but
      // clearing storage by hand. Signing in again is the one thing that can help here.
      this.setState({ isRedirecting: false, redirectUrl: "/login" });
    }
  }

  render() {
    return this.state.isRedirecting ? <KuikaSpinner /> : <Navigate to={this.state.redirectUrl} />;
  }
}

const redirect = withHistory<IRedirectProps>(Redirect);
export { redirect as Redirect };
